"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import { ShopProDetailModel } from "@/models/virtual-shop/ShopDetail.model";
let MoreDetail = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.cookieSyncMode = "";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  getUserList(userList) {
    if (userList === null || userList === "" || userList === void 0) {
      return "-";
    } else {
      const _list = new Array();
      for (const user of userList) {
        _list.push(user.name);
      }
      return _list.join("\uFF0C");
    }
  }
  getGruopList(groupList) {
    if (groupList === null || groupList === "" || groupList === void 0) {
      return "-";
    } else {
      const _list = new Array();
      for (const user of groupList) {
        _list.push(user.name);
      }
      return _list.join("\uFF0C");
    }
  }
  // getShopLock = (marks: TagsModel): boolean => {
  //   return marks.is("SHOP_LOCK");
  // };
  // public getCookieSyncMode(marks: TagsModel) {
  //   if (marks.is("AUTO_SYNC")) {
  //     this.cookieSyncMode = "AUTO_SYNC";
  //     return;
  //   }
  //   if (marks.is("BYUSER_SYNC")) {
  //     this.cookieSyncMode = "BYUSER_SYNC";
  //     return;
  //   }
  //   if (marks.is("NO_AUTO_SYNC")) {
  //     this.cookieSyncMode = "NO_AUTO_SYNC";
  //     return;
  //   }
  //   if (marks.is("MANUAL_SYNC")) {
  //     this.cookieSyncMode = "MANUAL_SYNC";
  //     return;
  //   }
  //   this.cookieSyncMode = "";
  // }
};
__decorateClass([
  PropSync("shopDetailData", {
    type: ShopProDetailModel,
    default: () => {
      return new ShopProDetailModel();
    }
  })
], MoreDetail.prototype, "_shopDetailData", 2);
MoreDetail = __decorateClass([
  Component({
    components: {}
  })
], MoreDetail);
export {
  MoreDetail as default
};
